import { selectIsEtazhiBlackFridayEnabled } from './selectIsEtazhiBlackFridayEnabled';
import { selectJsonQuery } from '../results';
import { getIsFlatSale } from 'shared/utils/etazhiBlackFriday';

import type { IAppState } from 'shared/common/state';

export const selectIsEtazhiBlackFridayPromoVisible = (state: IAppState): boolean => {
  const isEnabled = selectIsEtazhiBlackFridayEnabled(state);

  if (!isEnabled) {
    return false;
  }

  const jsonQuery = selectJsonQuery(state);

  // Только вторичка продажа квартир
  const isFlatSale = getIsFlatSale(jsonQuery);

  return isFlatSale;
};
